import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Spin, Upload, Space, message } from 'antd';
import { useMutation, gql } from '@apollo/client';
import { UploadOutlined } from '@ant-design/icons';

import ErrorBoundary from '../../components/Utils/ErrorBoundary';

const UPLOAD_FILE_QUERY = gql`
  mutation Upload($file: Upload!) {
    upload(file: $file) {
      path
      name
      mime
    }
  }
`;

const UploadFile = ({
  formId,
  maxNumberOfFile,
  mediaType,
  noSubmitButtons,
  onUploadSuccess,
  onFileRemoved,
  buttonLabel,
}) => {
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [form] = Form.useForm();

  const [
    uplodFile,
    // {
    // data: dataUpload,
    // loading: mutationUploadLoading,
    // error: mutationUploadError,
    // },
  ] = useMutation(UPLOAD_FILE_QUERY);

  const onFileUpload = ({ onSuccess, onError, file }) => {
    console.log('onFileUpload triggered with : ', file, onSuccess, onError);
    uplodFile({
      variables: {
        file: file,
      },
    })
      .then(({ data: { upload } }) => {
        console.log('onFileUpload SUCESS////', upload);
        console.log(file);
        onSuccess(null, upload);
        onUploadSuccess(upload);
      })
      .catch((e) => {
        console.log('mutationError ////', e, e.graphQLErrors);
        let error = 'Some error occured, Please try again !!!';
        message.error(error);
      });
  };

  const handleFileChanged = ({ file }) => {
    if (file.status === 'removed') {
      setFileList([]);
      onFileRemoved([]);
    } else if (file.status === 'uploading') {
      setUploading(true);
      setFileList([file]);
    } else if (file.status === 'done') {
      setUploading(false);
      setFileList([file]);
    }
  };
  const onFormSubmit = (values) => {
    console.log('Form submitted with ', values);
  };

  return (
    <ErrorBoundary>
      <Form
        layout="vertical"
        className="ant-form-custom"
        form={form}
        onFinish={onFormSubmit}
        id={formId}
        style={{ marginTop: '0' }}
      >
        <Form.Item
          name="file"
          rules={[{ required: true, message: 'Please select file to upload!' }]}
          style={{ marginTop: '2rem' }}
        >
          <Spin spinning={uploading}>
            <Upload
              name="file"
              fileList={fileList}
              customRequest={onFileUpload}
              onChange={handleFileChanged}
              maxCount={maxNumberOfFile}
              accept={mediaType}
            >
              {fileList && fileList.length < maxNumberOfFile && (
                <Button
                  icon={<UploadOutlined />}
                  disabled={fileList && fileList.length === maxNumberOfFile}
                >
                  {buttonLabel}
                </Button>
              )}
            </Upload>
          </Spin>
        </Form.Item>
        {!noSubmitButtons && (
          <Space>
            <Button type="secondary" size="middle" onClick={null}>
              Cancel
            </Button>
            <Button type="primary" size="middle" htmlType="submit">
              Add Employee
            </Button>
          </Space>
        )}
      </Form>
    </ErrorBoundary>
  );
};

UploadFile.defaultProps = {
  maxNumberOfFile: 1,
  mediaType:
    '.ppt, .pptx,application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  formId: 'upload-file',
  noSubmitButtons: true,
  buttonLabel: 'Click to upload',
};

UploadFile.propTypes = {
  maxNumberOfFile: PropTypes.number,
  mediaType: PropTypes.string,
  onUploadSuccess: PropTypes.func.isRequired,
  formId: PropTypes.string,
  noSubmitButtons: PropTypes.bool,
  buttonLabel: PropTypes.string,
};

export default UploadFile;
